import { render, staticRenderFns } from "./rec_video.vue?vue&type=template&id=534d3e80&"
import script from "./rec_video.vue?vue&type=script&lang=js&"
export * from "./rec_video.vue?vue&type=script&lang=js&"
import style0 from "./rec_video.vue?vue&type=style&index=0&id=534d3e80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports